import Banner from './Banner'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Slider from 'react-slick'
import { useRef } from 'react'
import { IBanner } from '@pages/front/types/type'

const data: IBanner[] = [
  {
    bgColor: '#e6f5fc',
    title:
      'Your All-In-One App For Doctors, Medicines, Lab Tests & Health Services',
    subTitle: `"Supchar - Complete Healthcare At Your Fingertips"`,
    imgSrc: '/phones/phoneImg1.png',
  },
  {
    bgColor: '#f5f3ff',
    title: 'From Symptoms To Solutions Start With A Search',
    subTitle: `"Find Doctors, Clinics, Lab Tests & Medicines Instantly."`,
    imgSrc: '/phones/phoneImg2.png',
  },
  {
    bgColor: '#feeaf0',
    title: 'Talk To A Doctor Instantly, Anytime, Anywhere.',
    subTitle: `"Book Clinic Visits Or Video Calls For Symptoms In Seconds"`,
    imgSrc: '/phones/phoneImg3.png',
  },
  {
    bgColor: '#fff4dd',
    title: 'Lab Tests & Medicines Book & Order Near You In A Tap',
    subTitle: `"Prescription? Sorted. Tests? Booked. All Nearby, All Simple"`,
    imgSrc: '/phones/phoneImg4.png',
  },
]

const BannerSlide = () => {
  const sliderRef = useRef<Slider>(null)

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: false,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    appendDots: (dots: React.ReactNode) => (
      <div
        style={{
          position: 'absolute',
          bottom: '10px',
          left: '50%',
          transform: 'translateX(-50%)',
          width: '100%',
        }}
      >
        <ul
          style={{
            margin: '0',
            padding: '0',
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '8px',
            height: '14px',
          }}
        >
          {dots}
        </ul>
      </div>
    ),
    customPaging: (i: number) => {
      const isActive = i === sliderRef.current?.innerSlider.state.currentSlide
      return (
        <div
          style={{
            width: isActive ? '10px' : '8px',
            height: isActive ? '10px' : '8px',
            borderRadius: '50%',
            backgroundColor: isActive ? '#263077' : '#dadcf9',
            transition: 'all 0.3s ease',
            cursor: 'pointer',
            marginTop: isActive ? '0' : '1px',
          }}
        />
      )
    },
  }

  return (
    <div style={{ position: 'relative' }}>
      <Slider ref={sliderRef} {...settings}>
        {data?.map((d, i) => <Banner key={i} data={d} />)}
      </Slider>
    </div>
  )
}

export default BannerSlide
